import React, { useState, useEffect } from "react";
import { Container, Button } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { map } from "lodash";
import { Menu } from "../../../api";
import { image } from "../../../assets";
import { socialData } from "../../../Utils";

import "./TopBar.scss";

const menuController = new Menu();

export function TopBar() {
  const [menu, setMenu] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await menuController.getMenus(true); //hay que mandar el active a getMenus
        setMenu(response.menus);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
    <div className="top-bar">
      <Container>
        <div className="top-bar__left">
          <Link to="/" className="logo-top">
            <img src={image.ejlogoFondo} alt="logo" />
          </Link>

          <div className="menu">
            {map(menu, (menus) => (
              <a key={menus._id} href={menus.path}>
                {menus.title}
              </a>
            ))}
          </div>
        </div>
        <div className="social">
          {map(socialData, (social) => (
            <Button
              key={social.type}
              as="a"
              href={social.link}
              color={social.type}
              target="_blank"
              icon={social.type}
            />
          ))}
        </div>
      </Container>
    </div>
  );
}
